import { getFullCaseName } from "../../helpers/small-helpers";
import { Citation } from "../../helpers/Models";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../components/ui/tooltip";

export const CitationSubtitle = ({ citation }: { citation: Citation }) => {
  const fullCaseName = getFullCaseName({
    citationText: citation.resource_text ?? citation.text,
    court: citation.court,
    dateFiled: citation.date_filed,
  });
  return <div className="text-[14px] text-[#5f6368]">{fullCaseName}</div>;
};

interface CitationTitleContainerProps {
  caseName?: string;
  link?: string;
}

export const CitationTitleContainer: React.FC<CitationTitleContainerProps> = ({ caseName, link }) => {
  const name = caseName ?? "Open Case";

  return link ? (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            className="no-underline text-[15px] text-sky-600 w-fit pb-0.5"
          >
            {name}
            {/* <ArrowTopRightOnSquareIcon height={14} width={14} /> */}
          </a>
        </TooltipTrigger>
        <TooltipContent align="center">{caseName}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  ) : (
    <div>{name}</div>
  );
};
